import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks';
import { GET_ADC_ALARM_STATUS } from '../../graphql/queries/Devices';
import { AlarmHardwareStatus as AlarmHardwareStatusData } from '../../types/HardwareStatus';
import HardwareStatusBadges from '../HardwareStatusBadges';
import Spinner from '../CustomSpinner';

type Props = {
  serialNumber: string;
};

const AlarmHardwareStatus: React.FC<Props> = ({ serialNumber }: Props) => {
  const { data, loading } = useQuery<{
    getAdcAlarmStatus?: AlarmHardwareStatusData;
  }>(GET_ADC_ALARM_STATUS, {
    variables: { serialNumber },
    fetchPolicy: 'network-only',
  });
  const alarmStatus = data?.getAdcAlarmStatus;

  return (
    <Box marginBottom={2} marginTop={1}>
      <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 6 }}>
        Alarm Status
      </Typography>
      {loading && <Spinner size={20} />}
      {!loading && alarmStatus && (
        <HardwareStatusBadges
          hardwareStatuses={alarmStatus.hardwareStatuses}
          deviceStatus={alarmStatus.deviceStatus}
          lockStatus={alarmStatus.lockStatus}
        />
      )}
      {!loading && !alarmStatus && (
        <Typography variant="body2" color="textSecondary">
          Alarm status is unavailable.
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(AlarmHardwareStatus);
